<template>
  <div>
    <v-toolbar dense flat>
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <v-text-field
            @input="searchinput($event)"
            prepend-icon="search"
            label="Search owner /tel. /email "
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filterActionlog"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props" v-if="data_loading">
        <td class="text-xs-center">
          {{ props.item.action_log_user.user_provider_wesmart_first_name
          }}<span class="ml-2">{{
            props.item.action_log_user.user_provider_wesmart_last_name
          }}</span>
        </td>

        <td class="text-xs-center">
          {{ props.item.action_log_company.company_provider_wesmart_name }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.action_log_company.company_provider_wesmart_type == 1
              ? "บุคคลธรรมดา"
              : props.item.action_log_company.company_provider_wesmart_type == 2
              ? "นิติบุคคล"
              : null
          }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.action_log_company.company_provider_wesmart_email == null
              ? "-"
              : props.item.action_log_company.company_provider_wesmart_email
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.action_log_company.company_provider_wesmart_tel }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.create_at).format("YYYY/MM/DD") }}
        </td>
        <td class="text-xs-center">
          <span
            :class="[
              props.item.action_log_company.company_provider_wesmart_status == 1
                ? 'badge_status--active'
                : props.item.action_log_company
                    .company_provider_wesmart_status == 2
                ? 'badge_status--inactive'
                : props.item.action_log_company
                    .company_provider_wesmart_status == 3
                ? 'badge_status--reject'
                : props.item.action_log_company
                    .company_provider_wesmart_status == 4
                ? 'badge_status--delete'
                : props.item.action_log_company
                    .company_provider_wesmart_status == 5
                ? 'badge_status--edit'
                : null,
            ]"
          >
            {{
              props.item.action_log_company.company_provider_wesmart_status == 1
                ? "Pending"
                : props.item.action_log_company
                    .company_provider_wesmart_status == 2
                ? "Approve"
                : props.item.action_log_company
                    .company_provider_wesmart_status == 3
                ? "Reject"
                : props.item.action_log_company
                    .company_provider_wesmart_status == 4
                ? "Delete"
                : props.item.action_log_company
                    .company_provider_wesmart_status == 5
                ? "Edit docs"
                : null
            }}
          </span>
        </td>
        <td class="text-xs-center">
          <v-btn
            icon
            @click="
              businessDeatil(
                props.item.action_log_company.company_provider_wesmart_id
              )
            "
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data"></template>
    </v-data-table>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  props: ["searchLog"],
  data: () => ({
    search: "",
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "Owner",
        value: "user_provider_wesmart_first_name",
        sortable: false,
        align: "center",
      },
      {
        text: "Business Name",
        value: "user_provider_wesmart_first_name",
        sortable: false,
        align: "center",
      },
      {
        text: "Type",
        sortable: false,
        value: "company_provider_wesmart_type",
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "user_provider_wesmart_email",
        align: "center",
      },
      {
        text: "Tel.",
        value: "user_provider_wesmart_tel",
        sortable: false,
        align: "center",
      },
      {
        text: "Date",
        value: "create_at",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        value: "company_provider_wesmart_status",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Action",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
    data_loading: false,
    watch: false,
  }),
  watch: {
    searchLog() {
      this.search = this.searchLog.status;
      this.watch = true;
    },
  },
  computed: {
    ...mapState({
      actionlog: (state) => state.Business.actionlog,
    }),
    filterActionlog() {
      if (this.watch) {
        return this.actionlog.filter((val) =>
          String(
            val.action_log_company.company_provider_wesmart_status
          ).includes(this.search)
        );
      } else {
        return this.actionlog.filter(
          (val) =>
            val.action_log_user.user_provider_wesmart_first_name
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            val.action_log_company.company_provider_wesmart_tel
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            val.action_log_company.company_provider_wesmart_email
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      }
    },
  },
  methods: {
    searchinput(text) {
      this.search = text;
      this.watch = false;
    },
    async getData() {
      this.loadingMessage = true;
      if (this.$route.name == "businesstable") {
        await this.$store.dispatch("Business/fetchBusinesslist", "1");
        this.data_loading = true;
      } else if (this.$route.name == "tablelog") {
        await this.$store.dispatch("Business/fetchActionLog");
        this.data_loading = true;
      }
      this.loadingMessage = false;
    },
    async businessDeatil(item) {
      if (!item) return;
      this.$router.push({
        name: "businessid",
        params: { business_id: item },
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.badge_status--active {
  color: #fbd200;
}
.badge_status--inactive {
  color: #4caf50;
}
.badge_status--reject {
  color: #fb3200;
}
.badge_status--delete {
  color: #9b9a99;
}
.badge_status--edit {
  color: #00baff;
}
</style>
